/*
 * AT.cart — minimal cart service (new, arlo-mott-style singleton).
 *
 * Namespaced on window.AT.cart. No build step; plain IIFE.
 * Uses Shopify's Cart AJAX API, including the Sections API so callers can get
 * freshly rendered section HTML back (e.g. the cart drawer) without coupling.
 *
 * Public API:
 *   AT.cart.add({ id, quantity, properties, sections, sectionsUrl }) -> Promise<json>
 *   AT.cart.get() -> Promise<cart json>
 *   AT.cart.onChange(key, cb) / AT.cart.offChange(key)
 */
(function initAtCart() {
  window.AT = window.AT || {};
  if (window.AT.cart) return;

  var ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var callbacks = {};

  var runCallbacks = function runCartCallbacks(payload) {
    Object.keys(callbacks).forEach(function (key) {
      try {
        callbacks[key](payload);
      } catch (err) {
        /* a broken listener must not break the cart flow */
        console.error('[AT.cart] callback error:', key, err);
      }
    });
  };

  var request = function cartRequest(url, body) {
    return fetch(ROUTES + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  };

  var add = function addToCart(opts) {
    var options = opts || {};
    var body = {
      items: [{ id: options.id, quantity: options.quantity || 1, properties: options.properties || {} }],
    };
    if (options.sections) {
      body.sections = options.sections;
      body.sections_url = options.sectionsUrl || window.location.pathname;
    }
    return request('cart/add.js', body).then(function (json) {
      runCallbacks({ type: 'add', response: json });
      return json;
    });
  };

  var get = function getCart() {
    return fetch(ROUTES + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  };

  var onChange = function addCartCallback(key, cb) {
    callbacks[key] = cb;
  };

  var offChange = function removeCartCallback(key) {
    delete callbacks[key];
  };

  window.AT.cart = { add: add, get: get, onChange: onChange, offChange: offChange };
})();
